<template>
  <v-navigation-drawer
    v-model="localDrawer"
    app
    temporary
    right
    :width="600"
    style="max-width: 90vw"
    @input="(val) => ctx.emit('update:drawer', val)"
  >
    <v-card elevation="0">
      <v-card-title class="d-flex justify-space-between align-center">
        <v-select
          v-model="limitCount"
          :items="[10, 20, 30, 40, 50]"
          label="履歴取得件数"
          dense
          hide-details
          style="max-width: 120px"
        />
        <v-btn icon @click="closeDrawer" aria-label="閉じる">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div
          v-for="(item, index) in desserts"
          :key="index"
          class="history-item"
        >
          <div class="pa-2 text-black">
            {{ index + 1 }}. {{ item.comment_type }}
          </div>
          <v-divider></v-divider>
          <div
            v-if="item.words"
            class="d-flex flex-row flex-wrap item-words pa-2 pb-0"
          >
            <span
              v-for="(word, index) in item.words"
              :key="index"
              class="px-2 py-1 ma-1 green lighten-6 rounded mini white--text font-bold"
              style="line-height: 1.2"
            >
              {{ word.replace(setting.text_input_label + "||", "") }}
            </span>
          </div>
          <div
            class="pa-2 text-black"
            v-html="item.comment.replace(/\n/g, '<br>')"
          ></div>
          <div class="mini pa-2 pt-0 text-right">{{ item.date_time }} 生成</div>
          <v-divider></v-divider>
          <div class="pa-2 d-flex align-center">
            <v-spacer></v-spacer>
            <div
              style="cursor: pointer"
              @click="copyToClipboard(item.comment, index)"
            >
              <v-icon small class="">mdi-content-copy</v-icon>
              <span>
                {{
                  copiedIndex === index
                    ? "コピーしました"
                    : "クリップボードにコピー"
                }}
              </span>
            </div>
          </div>
        </div>
        <div v-if="desserts.length === 0" class="text-center grey--text">
          履歴がありません。
        </div>
      </v-card-text>
    </v-card>
  </v-navigation-drawer>
</template>

<script>
import {
  reactive,
  toRefs,
  defineComponent,
  watch,
  ref,
  onMounted,
} from "@vue/composition-api";
import store from "@/store/index.js";
import setting from "@/common/setting.js";
import selectItem from "@/common/selectItem";
import { repositoryFactory } from "@/repository/repositoryFactory";

export default defineComponent({
  props: ["type", "cast_id", "drawer"],
  setup(props, ctx) {
    const CastAiHistoriesRepository = repositoryFactory.get("castAiHistories");

    const state = reactive({
      desserts: [],
      limitCount: 10,
      copiedIndex: null,
    });
    const localDrawer = ref(props.drawer);

    // props.drawerの変更を監視（親コンポーネントからの変更を反映）
    watch(
      () => props.drawer,
      (val) => {
        localDrawer.value = val;
      }
    );

    // ドロワーが閉じた時
    watch(localDrawer, (val, oldVal) => {
      if (oldVal === true && val === false) {
        ctx.emit("update:drawer", false);
      }
    });

    // ドロワーが開いた時、または、limitCountが変更された時にデータ取得
    watch(
      () => [localDrawer.value, state.limitCount],
      ([newDrawer]) => {
        if (newDrawer === true) {
          fetchData();
        }
      }
    );

    const closeDrawer = () => {
      localDrawer.value = false;
      ctx.emit("update:drawer", false);
    };

    const fetchData = async () => {
      state.desserts = [];
      store.dispatch("loadingIcon/showIcon"); // ローディング表示

      // 更新結果取得
      const params = {
        shop_id: store.getters["shops/currentShop"].id,
        cast_id: props.cast_id,
        comment_type: props.type,
        limit: state.limitCount,
      };
      await CastAiHistoriesRepository.list(params)
        .then((response) => {
          if (response.data) {
            Object.keys(response.data).forEach(function (key) {
              let objResponse = "";
              if (
                response.data[key].response !== null &&
                response.data[key].response !== ""
              ) {
                objResponse = JSON.parse(response.data[key].response);
              }
              const st = response.data[key].created_at.split("T");
              const words = [];
              if (
                response.data[key].prompt !== null &&
                response.data[key].prompt !== ""
              ) {
                const objPrompt = JSON.parse(response.data[key].prompt);
                const target_cast = objPrompt["target_cast"];
                Object.keys(target_cast).forEach(function (k) {
                  if (
                    k === "personality" ||
                    k === "specialty" ||
                    k === "hobbies" ||
                    k === "keywords"
                  ) {
                    if (target_cast[k] !== null && target_cast[k].length > 0) {
                      words.push(target_cast[k]);
                    }
                  }
                });
              }

              state.desserts.push({
                id: response.data[key].id,
                date_time:
                  st[0].replace(/-/g, "/") + " " + st[1].substring(0, 8),
                image: response.data[key].cast_image,
                name: response.data[key].cast_name,
                comment_type:
                  setting.comment_type_name[response.data[key].comment_type] ||
                  "",
                words: words,
                comment: objResponse["generated_comment"] || "",
              });
            });
          }
        })
        .catch((error) => {
          throw "ERROR:CastAiHistoriesRepository.list (" + error + ")";
        });

      store.dispatch("loadingIcon/hideIcon"); // ローディング非表示
    };

    const copyToClipboard = async (text, index) => {
      if (!text) return;
      navigator.clipboard.writeText(text).then(() => {
        state.copiedIndex = index;
        setTimeout(() => {
          state.copiedIndex = null;
        }, 3000);
      });
    };

    return {
      ctx,
      props,
      setting,
      selectItem,
      localDrawer,
      ...toRefs(state),
      fetchData,
      copyToClipboard,
      closeDrawer,
    };
  },
});
</script>

<style scoped>
.history-item {
  border: 0px solid #e0e0e0;
  border-radius: 8px;
  margin-bottom: 24px;
  background-color: #e3f2fd;
}
</style>
